import { React } from 'react';
import daylightCircle from '../../../../../Images/daylight full circle 6.19.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import {
    UncontrolledDropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
} from 'reactstrap';

const DaylightSyncCard = ({
    canManageDaylightSync,
    canViewDaylightCodeMapping,
    triggerSyncCallback,
    triggerCodeConverterCallback,
    triggerCodeMappingCallback
}) => {
    const dropdown = (canManageDaylightSync || canViewDaylightCodeMapping)
        ? <ManagementOptions 
            canManageDaylightSync={canManageDaylightSync}
            canViewDaylightCodeMapping={canViewDaylightCodeMapping}
            triggerSyncCallback={triggerSyncCallback}
            triggerCodeConverterCallback={triggerCodeConverterCallback}
            triggerCodeMappingCallback={triggerCodeMappingCallback} />
        : <></>;
    
    return (
        <div
            className="my-1"
            style={{ minWidth: '325px', maxWidth: '325px' }}>
            <div className="sc-rounded sc-shadow d-flex justify-content-between bg-info">
                <div className="align-self-center">
                    <div className="px-2">
                        <img
                            src={daylightCircle}
                            alt="Daylight logo"
                            height="50px"
                        />
                    </div>
                </div>
                <div className="w-100 text-12 p-2 bg-dark-opacity-3 sc-rounded text-center">
                    <h6>Daylight</h6>
                    Mappings
                </div>
                <div>
                    {dropdown}
                </div>
            </div>
        </div>
    );
}

const ManagementOptions = ({ canManageDaylightSync, canViewDaylightCodeMapping, triggerSyncCallback, triggerCodeConverterCallback, triggerCodeMappingCallback }) => {
    return (
        <UncontrolledDropdown direction="up">
            <DropdownToggle
                nav
                className="text-light"
                style={{
                    position: 'absolute',
                    right: '0px',
                }}>
                <FontAwesomeIcon
                    icon={faEllipsisV}
                    size="lg"
                />
            </DropdownToggle>
            <DropdownMenu
                right
                className="zindex-tooltip">
                {canManageDaylightSync && (
                    <>
                        <DropdownItem onClick={() => triggerSyncCallback()}>
                            Sync to Daylight
                        </DropdownItem>
                        <DropdownItem onClick={() => triggerCodeConverterCallback()}>
                            Run Code Converter
                        </DropdownItem>
                    </>
                )}
                {canViewDaylightCodeMapping && (
                    <DropdownItem
                        onClick={() => triggerCodeMappingCallback()}>
                        View Code Maps
                    </DropdownItem>
                )}
            </DropdownMenu>
        </UncontrolledDropdown>
    );
}

export default DaylightSyncCard;